import { MapContainer, TileLayer, Circle, CircleMarker, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useMemo } from "react";

const CAT_COLOR = {
    priorita_alta: "#047857",
    interessante: "#2563eb",
    monitorare: "#ca8a04",
    scartare: "#9ca3af",
};

const fmtEur = (n) =>
    n == null ? "—" : new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

// Black square "AI" pin for the search center (the chosen comune)
const centerIcon = L.divIcon({
    className: "",
    html: '<div style="background:#000;color:#fff;width:26px;height:26px;display:flex;align-items:center;justify-content:center;font-weight:900;font-size:11px;border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.4);">★</div>',
    iconSize: [26, 26],
    iconAnchor: [13, 13],
});

function FitToRadius({ center, radiusKm }) {
    const map = useMap();
    useEffect(() => {
        if (!center) return;
        const r = radiusKm * 1000;
        const latDelta = r / 111320;
        const lngDelta = r / (111320 * Math.cos((center.lat * Math.PI) / 180));
        const bounds = L.latLngBounds(
            [center.lat - latDelta, center.lng - lngDelta],
            [center.lat + latDelta, center.lng + lngDelta]
        );
        map.fitBounds(bounds, { padding: [24, 24] });
    }, [map, center, radiusKm]);
    return null;
}

export default function RadarMap({ center, radiusKm, items }) {
    const points = useMemo(
        () => (items || []).filter((it) => it.lat != null && it.lng != null),
        [items]
    );
    if (!center) return null;

    return (
        <div
            className="border border-gray-200 mb-6 overflow-hidden"
            data-testid="radar-map"
            style={{ height: 360 }}
        >
            <MapContainer
                center={[center.lat, center.lng]}
                zoom={11}
                scrollWheelZoom={false}
                style={{ height: "100%", width: "100%" }}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Circle
                    center={[center.lat, center.lng]}
                    radius={radiusKm * 1000}
                    pathOptions={{ color: "#111", weight: 1.5, fillColor: "#111", fillOpacity: 0.05 }}
                />
                <Marker position={[center.lat, center.lng]} icon={centerIcon}>
                    <Popup>
                        <strong>{center.label || "Centro ricerca"}</strong>
                        <br />Raggio {radiusKm} km
                    </Popup>
                </Marker>
                {points.map((it) => (
                    <CircleMarker
                        key={it.id}
                        center={[it.lat, it.lng]}
                        radius={7}
                        pathOptions={{
                            color: "#fff",
                            weight: 1.5,
                            fillColor: CAT_COLOR[it.prescreening_category] || "#2563eb",
                            fillOpacity: 0.95,
                        }}
                    >
                        <Popup>
                            <strong>{(it.property_type || "Immobile").replace(/_/g, " ")}</strong>
                            <br />{it.municipality || it.province}
                            {it.distance_km != null && <> · {it.distance_km} km</>}
                            <br />Score {it.prescreening_score} · Base {fmtEur(it.base_price)}
                        </Popup>
                    </CircleMarker>
                ))}
                <FitToRadius center={center} radiusKm={radiusKm} />
            </MapContainer>
        </div>
    );
}
